module.exports = __webpack_public_path__ + "static/media/child.18b520d7.svg";